export const DEPLOYMENT_SETTING_LIST_DEPLOYMENT_SETTING_BEGIN =
  'DEPLOYMENT_SETTING_LIST_DEPLOYMENT_SETTING_BEGIN';
export const DEPLOYMENT_SETTING_LIST_DEPLOYMENT_SETTING_SUCCESS =
  'DEPLOYMENT_SETTING_LIST_DEPLOYMENT_SETTING_SUCCESS';
export const DEPLOYMENT_SETTING_LIST_DEPLOYMENT_SETTING_FAILURE =
  'DEPLOYMENT_SETTING_LIST_DEPLOYMENT_SETTING_FAILURE';
export const DEPLOYMENT_SETTING_LIST_DEPLOYMENT_SETTING_DISMISS_ERROR =
  'DEPLOYMENT_SETTING_LIST_DEPLOYMENT_SETTING_DISMISS_ERROR';
export const DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_BEGIN =
  'DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_BEGIN';
export const DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_SUCCESS =
  'DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_SUCCESS';
export const DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_FAILURE =
  'DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_FAILURE';
export const DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_DISMISS_ERROR =
  'DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_DISMISS_ERROR';
export const DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_BEGIN =
  'DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_BEGIN';
export const DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_SUCCESS =
  'DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_SUCCESS';
export const DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_FAILURE =
  'DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_FAILURE';
export const DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_DISMISS_ERROR =
  'DEPLOYMENT_SETTING_DELETE_DEPLOYMENT_SETTING_DISMISS_ERROR';
export const DEPLOYMENT_SETTING_UPDATE_DEPLOYMENT_SETTING_BEGIN =
  'DEPLOYMENT_SETTING_UPDATE_DEPLOYMENT_SETTING_BEGIN';
export const DEPLOYMENT_SETTING_UPDATE_DEPLOYMENT_SETTING_SUCCESS =
  'DEPLOYMENT_SETTING_UPDATE_DEPLOYMENT_SETTING_SUCCESS';
export const DEPLOYMENT_SETTING_UPDATE_DEPLOYMENT_SETTING_FAILURE =
  'DEPLOYMENT_SETTING_UPDATE_DEPLOYMENT_SETTING_FAILURE';
export const DEPLOYMENT_SETTING_UPDATE_DEPLOYMENT_SETTING_DISMISS_ERROR =
  'DEPLOYMENT_SETTING_UPDATE_DEPLOYMENT_SETTING_DISMISS_ERROR';
export const DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_BEGIN =
  'DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_BEGIN';
export const DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_SUCCESS =
  'DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_SUCCESS';
export const DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_FAILURE =
  'DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_FAILURE';
export const DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_DISMISS_ERROR =
  'DEPLOYMENT_SETTING_PUBLISH_DEPLOYMENT_SETTING_DISMISS_ERROR';
export const DEPLOYMENT_SETTING_LOAD_PROJECT_DEP_SETTING_BEGIN =
  'DEPLOYMENT_SETTING_LOAD_PROJECT_DEP_SETTING_BEGIN';
export const DEPLOYMENT_SETTING_LOAD_PROJECT_DEP_SETTING_SUCCESS =
  'DEPLOYMENT_SETTING_LOAD_PROJECT_DEP_SETTING_SUCCESS';
export const DEPLOYMENT_SETTING_LOAD_PROJECT_DEP_SETTING_FAILURE =
  'DEPLOYMENT_SETTING_LOAD_PROJECT_DEP_SETTING_FAILURE';
export const DEPLOYMENT_SETTING_LOAD_PROJECT_DEP_SETTING_DISMISS_ERROR =
  'DEPLOYMENT_SETTING_LOAD_PROJECT_DEP_SETTING_DISMISS_ERROR';
export const DEPLOYMENT_SETTING_LOAD_CODE_EXPORT_REQUEST_LIST_BEGIN =
  'DEPLOYMENT_SETTING_LOAD_CODE_EXPORT_REQUEST_LIST_BEGIN';
export const DEPLOYMENT_SETTING_LOAD_CODE_EXPORT_REQUEST_LIST_SUCCESS =
  'DEPLOYMENT_SETTING_LOAD_CODE_EXPORT_REQUEST_LIST_SUCCESS';
export const DEPLOYMENT_SETTING_LOAD_CODE_EXPORT_REQUEST_LIST_FAILURE =
  'DEPLOYMENT_SETTING_LOAD_CODE_EXPORT_REQUEST_LIST_FAILURE';
export const DEPLOYMENT_SETTING_LOAD_CODE_EXPORT_REQUEST_LIST_DISMISS_ERROR =
  'DEPLOYMENT_SETTING_LOAD_CODE_EXPORT_REQUEST_LIST_DISMISS_ERROR';
export const DEPLOYMENT_SETTING_LOAD_PERMISSION_FLAGS_BEGIN =
  'DEPLOYMENT_SETTING_LOAD_PERMISSION_FLAGS_BEGIN';
export const DEPLOYMENT_SETTING_LOAD_PERMISSION_FLAGS_SUCCESS =
  'DEPLOYMENT_SETTING_LOAD_PERMISSION_FLAGS_SUCCESS';
export const DEPLOYMENT_SETTING_LOAD_PERMISSION_FLAGS_FAILURE =
  'DEPLOYMENT_SETTING_LOAD_PERMISSION_FLAGS_FAILURE';
export const DEPLOYMENT_SETTING_LOAD_PERMISSION_FLAGS_DISMISS_ERROR =
  'DEPLOYMENT_SETTING_LOAD_PERMISSION_FLAGS_DISMISS_ERROR';
export const DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_BEGIN =
  'DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_BEGIN';
export const DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_SUCCESS =
  'DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_SUCCESS';
export const DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_FAILURE =
  'DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_FAILURE';
export const DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_DISMISS_ERROR =
  'DEPLOYMENT_SETTING_EXPORT_PROJECT_CODE_DISMISS_ERROR';
export const DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_BEGIN =
  'DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_BEGIN';
export const DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_SUCCESS =
  'DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_SUCCESS';
export const DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_FAILURE =
  'DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_FAILURE';
export const DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_DISMISS_ERROR =
  'DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_DISMISS_ERROR';
export const DEPLOYMENT_SETTING_LOAD_DOWNLOAD_CODE_HISTORY_BEGIN =
  'DEPLOYMENT_SETTING_LOAD_DOWNLOAD_CODE_HISTORY_BEGIN';
export const DEPLOYMENT_SETTING_LOAD_DOWNLOAD_CODE_HISTORY_SUCCESS =
  'DEPLOYMENT_SETTING_LOAD_DOWNLOAD_CODE_HISTORY_SUCCESS';
export const DEPLOYMENT_SETTING_LOAD_DOWNLOAD_CODE_HISTORY_FAILURE =
  'DEPLOYMENT_SETTING_LOAD_DOWNLOAD_CODE_HISTORY_FAILURE';
export const DEPLOYMENT_SETTING_LOAD_DOWNLOAD_CODE_HISTORY_DISMISS_ERROR =
  'DEPLOYMENT_SETTING_LOAD_DOWNLOAD_CODE_HISTORY_DISMISS_ERROR';
export const DEPLOYMENT_SETTING_TOGGLE_CODE_EXPORT = 'DEPLOYMENT_SETTING_TOGGLE_CODE_EXPORT';
export const DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_BEGIN =
  'DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_BEGIN';
export const DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_SUCCESS =
  'DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_SUCCESS';
export const DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_FAILURE =
  'DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_FAILURE';
export const DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_DISMISS_ERROR =
  'DEPLOYMENT_SETTING_REQUEST_UPGRADE_ACCOUNT_DISMISS_ERROR';
export const DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_BEGIN =
  'DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_BEGIN';
export const DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_SUCCESS =
  'DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_SUCCESS';
export const DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_FAILURE =
  'DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_FAILURE';
export const DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_DISMISS_ERROR =
  'DEPLOYMENT_SETTING_SAVE_DB_EXPORT_REQUEST_DISMISS_ERROR';
export const DEPLOYMENT_SETTING_DELETE_DB_EXPORT_REQUEST_BEGIN =
  'DEPLOYMENT_SETTING_DELETE_DB_EXPORT_REQUEST_BEGIN';
export const DEPLOYMENT_SETTING_DELETE_DB_EXPORT_REQUEST_SUCCESS =
  'DEPLOYMENT_SETTING_DELETE_DB_EXPORT_REQUEST_SUCCESS';
export const DEPLOYMENT_SETTING_DELETE_DB_EXPORT_REQUEST_FAILURE =
  'DEPLOYMENT_SETTING_DELETE_DB_EXPORT_REQUEST_FAILURE';
export const DEPLOYMENT_SETTING_DELETE_DB_EXPORT_REQUEST_DISMISS_ERROR =
  'DEPLOYMENT_SETTING_DELETE_DB_EXPORT_REQUEST_DISMISS_ERROR';
export const DEPLOYMENT_SETTING_LOAD_DB_EXPORT_REQUEST_LIST_BEGIN =
  'DEPLOYMENT_SETTING_LOAD_DB_EXPORT_REQUEST_LIST_BEGIN';
export const DEPLOYMENT_SETTING_LOAD_DB_EXPORT_REQUEST_LIST_SUCCESS =
  'DEPLOYMENT_SETTING_LOAD_DB_EXPORT_REQUEST_LIST_SUCCESS';
export const DEPLOYMENT_SETTING_LOAD_DB_EXPORT_REQUEST_LIST_FAILURE =
  'DEPLOYMENT_SETTING_LOAD_DB_EXPORT_REQUEST_LIST_FAILURE';
export const DEPLOYMENT_SETTING_LOAD_DB_EXPORT_REQUEST_LIST_DISMISS_ERROR =
  'DEPLOYMENT_SETTING_LOAD_DB_EXPORT_REQUEST_LIST_DISMISS_ERROR';

export const DEPLOYMENT_SETTING_DELETE_GITHUB_EXPORT_REQUEST =
  'DEPLOYMENT_SETTING_DELETE_GITHUB_EXPORT_REQUEST';
export const DEPLOYMENT_SETTING_DELETE_GITHUB_EXPORT_REQUEST_BEGIN =
  'DEPLOYMENT_SETTING_DELETE_GITHUB_EXPORT_REQUEST_BEGIN';
export const DEPLOYMENT_SETTING_DELETE_GITHUB_EXPORT_REQUEST_SUCCESS =
  'DEPLOYMENT_SETTING_DELETE_GITHUB_EXPORT_REQUEST_SUCCESS';
export const DEPLOYMENT_SETTING_DELETE_GITHUB_EXPORT_REQUEST_FAILURE =
  'DEPLOYMENT_SETTING_DELETE_GITHUB_EXPORT_REQUEST_FAILURE';

export const DEPLOYMENT_SETTING_LIST_GITHUB_EXPORT_LIST =
  'DEPLOYMENT_SETTING_LIST_GITHUB_EXPORT_LIST';
export const DEPLOYMENT_SETTING_LIST_GITHUB_EXPORT_LIST_BEGIN =
  'DEPLOYMENT_SETTING_LIST_GITHUB_EXPORT_LIST_BEGIN';
export const DEPLOYMENT_SETTING_LIST_GITHUB_EXPORT_LIST_SUCCESS =
  'DEPLOYMENT_SETTING_LIST_GITHUB_EXPORT_LIST_SUCCESS';
export const DEPLOYMENT_SETTING_LIST_GITHUB_EXPORT_LIST_FAILURE =
  'DEPLOYMENT_SETTING_LIST_GITHUB_EXPORT_LIST_FAILURE';

export const DEPLOYMENT_SETTING_EXPORT_CODE_TO_GITHUB = 'DEPLOYMENT_SETTING_EXPORT_CODE_TO_GITHUB';
export const DEPLOYMENT_SETTING_CREATE_GITHUB_EXPORT_SETTING =
  'DEPLOYMENT_SETTING_CREATE_GITHUB_EXPORT_SETTING';

export const DEPLOYMENT_SETTING_CREATE_GITHUB_EXPORT_SETTING_BEGIN =
  'DEPLOYMENT_SETTING_CREATE_GITHUB_EXPORT_SETTING_BEGIN';
export const DEPLOYMENT_SETTING_CREATE_GITHUB_EXPORT_SETTING_SUCCESS =
  'DEPLOYMENT_SETTING_CREATE_GITHUB_EXPORT_SETTING_SUCCESS';
export const DEPLOYMENT_SETTING_CREATE_GITHUB_EXPORT_SETTING_FAILURE =
  'DEPLOYMENT_SETTING_CREATE_GITHUB_EXPORT_SETTING_FAILURE';
export const DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_BEGIN =
  'DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_BEGIN';
export const DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_SUCCESS =
  'DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_SUCCESS';
export const DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_FAILURE =
  'DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_FAILURE';
export const DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_DISMISS_ERROR =
  'DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_DISMISS_ERROR';
export const DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_BEGIN = 'DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_BEGIN';
export const DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_SUCCESS =
  'DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_SUCCESS';
export const DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_FAILURE =
  'DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_FAILURE';
export const DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_DISMISS_ERROR =
  'DEPLOYMENT_SETTING_PUSH_TO_GIT_HUB_DISMISS_ERROR';
